<form (ngSubmit)="openIdConnect()">

  <div *ngIf="externalAuth?.msgHeader != ''" class="msg-header" [innerHTML]="externalAuth?.msgHeader | safe">
  </div>

  <input *ngIf="externalAuth?.providerButtonImage else oidcButtonWithoutImage" type="image"
    (mouseover)="mouseover = true" (mouseout)="mouseover = false"
    [src]="(mouseover && externalAuth?.providerButtonHoverImage && externalAuth?.providerButtonHoverImage != '') ? externalAuth?.providerButtonHoverImage : externalAuth?.providerButtonImage"
    class="open-id-button" [value]="'S\'identifier avec '+externalAuth?.providerName">

  <ng-template #oidcButtonWithoutImage>
    <button id="btnOidcLogin" mat-raised-button color="primary" type="submit" class="open-id-button">
      <span>S'identifier avec {{externalAuth?.providerName}}</span>
    </button>
  </ng-template>

  <div *ngIf="externalAuth?.linkInfoLabel !== '' && externalAuth?.linkInfoUrl !== ''" class="">
    <a [href]="externalAuth?.linkInfoUrl" target="_blank">
      {{externalAuth?.linkInfoLabel}}
      <i class="fas fa-external-link-alt"></i>
    </a>
  </div>
</form>
